import { render, staticRenderFns } from "./PayUStrategy.vue?vue&type=template&id=71db56e5"
import script from "./PayUStrategy.vue?vue&type=script&lang=ts"
export * from "./PayUStrategy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports